import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const staffMappingData = createReducer(
  {
    mappings: [],
    updating: false,
  },
  {
    [types.GET_STAFF_MAPPING_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });
      return newState;
    },
    [types.GET_STAFF_MAPPING_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        mappings: action.mappings,
        loading: false,
      });
      return newState;
    },
    [types.GET_STAFF_MAPPING_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        loading: false,
      });
      return newState;
    },

    [types.UPDATE_STAFF_MAPPING_START](state) {
      const newState = Object.assign({}, state, {
        updating: true,
        mappingUpdated: false,
      });

      return newState;
    },
    [types.UPDATE_STAFF_MAPPING_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        updating: false,
        mappingUpdated: true,
      });
      return newState;
    },
    [types.UPDATE_STAFF_MAPPING_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        updating: false,
        mappingUpdated: false,
      });
      return newState;
    },

    [types.DELETE_STAFF_MAPPING_START](state) {
      const newState = Object.assign({}, state, {
        deleting: true,
        mappingDeleted: false,
      });

      return newState;
    },
    [types.DELETE_STAFF_MAPPING_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        deleting: false,
        mappingDeleted: true,
      });
      return newState;
    },
    [types.DELETE_STAFF_MAPPING_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        deleting: false,
        mappingDeleted: false,
      });
      return newState;
    },
  },
);

export { staffMappingData as default };
